import { useEffect, useState } from "react";
import { Button, Typography, Box } from "@mui/material";
import {
  useSetMessageFireStatusMutation,
  useLazyGetMessageFireInfoQuery,
  useGetMessageStatusesPostMutation,
} from "../../../middleware/messageCodeApi";
import dayjs from "dayjs";
import { useTranslation } from "react-i18next";
import InputTextarea from "../InputTextarea";
import { formatAddress } from "../../../helpers/helper";
import { dateFormatWithTimeWithoutA } from "../../../constants";
import InputText from "../InputText";
import "./style.css";
import { cancelCauses, ModalConfirmPageWithCheckbox } from "../Modals/ModalConfirmPageWithCheckbox";
import { ModalConfirmPageWithinput } from "../Modals/ModalConfirmPageWithinput";
import { useLazyGetMessageSummariesPerSessionQuery } from "../../../middleware/analyticsApi";
import {
  useLazyGetAllFacilitiesQuery,
  useLazyGetFacilitiesMapElementsInfoQuery,
} from "../../../middleware/facilitiesApi";
import { useLazyGetAllMagazineEventsQuery } from "../../../middleware/magazineApi";

export const EventCard = ({ messageId, fetchData, setrefetchAfterAccept }) => {
  const [itemData, setItemdata] = useState({});
  const [openCancelModal, setOpenCancelModal] = useState(false);
  const [openAcceptModal, setOpenAcceptModal] = useState(false);
  const [detailsMessage, setDetailsMessage] = useState("");

  const [getMessageSummariesPerSession] = useLazyGetMessageSummariesPerSessionQuery();
  const [getFacilitiesTable] = useLazyGetAllFacilitiesQuery();
  const [getAllMagazineEvents] = useLazyGetAllMagazineEventsQuery();
  const [getMessageFire] = useLazyGetMessageFireInfoQuery();
  const [SetMessageFireStatus] = useSetMessageFireStatusMutation();
  const [getMessageStatusesPost] = useGetMessageStatusesPostMutation();
  const [getFacilitiesMapElementsInfo] = useLazyGetFacilitiesMapElementsInfoQuery();

  const getMessageInfo = () => {
    getMessageFire({ messageId }).then(({ data }) => {
      setItemdata(data);
      setDetailsMessage((prev) => (data?.triggerCause ? data?.triggerCause : prev));
    });
  };

  useEffect(() => {
    getMessageInfo();
  }, [messageId]);

  useEffect(() => {
    const intervalId = setInterval(() => {
      if (!messageId) return;
      getMessageStatusesPost([messageId]).then((response) => {
        if (response.error) {
          return;
        }

        if (response.data[0].status !== itemData.fireStatus) {
          getMessageInfo();
        }
      });
    }, 1000);

    return () => clearInterval(intervalId);
  }, [messageId]);

  const changeDetailes = (e) => {
    setDetailsMessage(e.target.value);
  };

  const setFireStatus = (status, cause, comment) => {
    SetMessageFireStatus({
      MessageId: messageId,
      Details: comment || detailsMessage || "Подтверждение",
      reasonType: cause || 0,
      Status: status,
    }).then((result) => {
      if ("error" in result) {
        return;
      }
      refetchApis(itemData?.isProcessed);
      setrefetchAfterAccept(true);
      getMessageFire({ messageId }).then(({ data }) => {
        setItemdata(data);
        setDetailsMessage(data?.triggerCause);
      });
      setOpenCancelModal(false);
      setOpenAcceptModal(false);
    });
  };

  const address = formatAddress(itemData?.protectionObjectAddress);
  const dateTime = dayjs(itemData?.reactionTime).format(dateFormatWithTimeWithoutA);

  const cancelTrigger = (cause) => {
    setFireStatus(2, cause, "");
  };

  const acceptTrigger = (comment) => {
    setFireStatus(1, "", comment);
  };

  const getReasonType = (reason) => {
    if (!reason) return "";
    const findReason = cancelCauses.find(({ id }) => id === reason);
    if (!findReason) return;
    return `, ${findReason?.name}`;
  };

  function refetchApis(isProccessed) {
    if (!isProccessed) fetchData(0);
    getMessageSummariesPerSession();
    getFacilitiesMapElementsInfo();
    getFacilitiesTable({
      pageNumber: 0,
    });
    getAllMagazineEvents({
      pageNumber: 0,
    });
  }

  return (
    <Box className="eventCard">
      <ModalConfirmPageWithCheckbox
        open={openCancelModal}
        setOpen={setOpenCancelModal}
        call={cancelTrigger}
        text={"Выберите причину отмены тревоги"}
      />
      <ModalConfirmPageWithinput
        open={openAcceptModal}
        setOpen={setOpenAcceptModal}
        call={acceptTrigger}
        text={"Подтверждение пожара"}
        placeholder={"placeholder:comment"}
      />
      <Box className="eventCardBox">
        <Typography className="eventDateText">{"Данные обекта"}</Typography>
        <Box className="eventObjectInfo">
          <Box
            component="img"
            className="eventObjectAvatar"
            src={itemData?.protectionObjectPhoto || itemData?.protectionObjectPhotoLink || "/unnamed.png"}
          />
          <Box className="eventObjectInfoBox">
            <Typography className="eventDateText">{itemData?.protectObjectName || ""}</Typography>
            <Typography className="eventDateTextsecond">{address}</Typography>
            <Typography className="eventDateTextsecond">{itemData?.protectionObjectPhone || ""}</Typography>
          </Box>
        </Box>
        <Box className="eventReactionDateBox" sx={{}}>
          <Typography className="eventDateText">Данные о срабатывании</Typography>
          <Typography className="eventDateTextsecond">{dateTime}</Typography>
        </Box>
        <Box className="eventReactionDateBox">
          <InputText
            label={"label:messageClass"}
            value={itemData?.messageCodeTypeName}
            sx={{
              fontSize: "16px !important",
              color: "#6C6E70",
              fontWeight: 600,
            }}
            disabled
          />
          <InputText
            label={"label:roomPlume"}
            value={itemData?.plume}
            sx={{
              fontSize: "16px !important",
              color: "#6C6E70",
              fontWeight: 600,
            }}
            disabled
          />
        </Box>

        {itemData?.isProcessed ? (
          itemData?.messageActions?.length && (
            <Box className="messageAction">
              {itemData?.messageActions?.map(
                ({ dateTime, userFullName, fireStatus, reasonType, triggerCause }, index) => (
                  <Box className="card" sx={{ backgroundColor: index === 0 ? "#f4f4f4" : "#fff" }}>
                    <Box className="cardHead">
                      <Typography className="userText">{userFullName}</Typography>
                      <Typography className="dateText">{dayjs(dateTime).format(dateFormatWithTimeWithoutA)}</Typography>
                    </Box>
                    <Typography className="triggerText">
                      {fireStatus === 1
                        ? `Подтвеждение ${triggerCause || ""}`
                        : `Отмена тревоги${getReasonType(reasonType)}`}
                    </Typography>
                  </Box>
                )
              )}
            </Box>
          )
        ) : (
          <InputTextarea
            value={detailsMessage}
            onChange={(e) => changeDetailes(e)}
            label={"Причина срабатывания"}
            placeholder={"placeholder:comment"}
            sx={{
              fontSize: "16px !important",
              color: "#6C6E70",
              fontWeight: 600,
            }}
          />
        )}
      </Box>
      <Box
        sx={{
          display: "flex",
          alignSelf: "end",
          paddingBottom: "8px",
        }}
      >
        {/* <Button
          onClick={() => setFireStatus(2, true)}
          sx={{ height: "48px" }}
          className="btn btn-white"
          startIcon={<PrintIcon />}
        >
          Распечатать
        </Button>*/}

        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            gap: "8px",
          }}
        >
          {(!itemData?.isProcessed || itemData?.fireStatus === 1) && (
            <Button
              onClick={() => setOpenCancelModal(true)}
              sx={{ backgroundColor: "#FB0004 !important", height: "48px" }}
              className="btn btn-primary-fill"
              color="error"
            >
              Отменить
            </Button>
          )}
          {(!itemData?.isProcessed || itemData?.fireStatus === 2) && (
            <Button
              onClick={() => {
                if (itemData?.isProcessed) {
                  setOpenAcceptModal(true);
                  return;
                }
                setFireStatus(1);
              }}
              sx={{ height: "48px" }}
              className="btn btn-primary-fill"
              color="success"
            >
              Подтвердить
            </Button>
          )}
        </Box>
      </Box>
    </Box>
  );
};
